// searchModal.js - Global Event Dispatcher for Search & Suggestion Modal

export function openSearchModal(query = '') {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('oz:open-search-modal', { detail: { query } }));
  }
}
